import type AutocompleteElement from '@github/auto-complete-element'
import {observe} from '@github-ui/selector-observer'
import {on} from 'delegated-events'

// Reset user selecting autocompleter, avoiding submission of partial matches.
function resetUserAddForm(form: Element, enabled: boolean) {
  const submit = form.querySelector<HTMLButtonElement>('.js-add-new-user')
  if (submit) submit.disabled = !enabled
}

// Ensure user selecting submit button is disabled on page load (including via pjax)
observe('.js-add-user-form', function (form) {
  resetUserAddForm(form, false)
})

on('auto-complete-change', '.js-add-user-completer', function ({target: completer}) {
  const autocompleter = completer as AutocompleteElement
  const form = document.querySelector<HTMLFormElement>('.js-add-user-form')
  if (form) resetUserAddForm(form, !!autocompleter.value)

  const designatedUser = document.querySelector('.js-designated-user')
  if (designatedUser) {
    if (autocompleter.value) {
      designatedUser.textContent = `@${autocompleter.value}`
    } else {
      designatedUser.textContent = designatedUser.getAttribute('data-autocomplete-text')
    }
  }

  const blockUserButton = document.querySelector<HTMLButtonElement>('.js-block-user-button')
  const blockUserDialog = document.getElementById('block-user-confirmation-dialog') as HTMLDialogElement

  if (blockUserButton) {
    if (autocompleter.value === '') {
      blockUserButton.setAttribute('aria-disabled', 'true')
      blockUserButton.classList.add('Button--inactive')
      blockUserButton.onclick = e => e.preventDefault()
    } else {
      blockUserButton.removeAttribute('aria-disabled')
      blockUserButton.classList.remove('Button--inactive')
      blockUserButton.onclick = () => blockUserDialog.showModal()
    }
  }
})

// Updates the duration of a blocked user, if available
on('click', '.js-duration-option', function ({currentTarget}) {
  const durationValue = currentTarget.getAttribute('data-duration-value')
  if (!durationValue) return

  const dialogDurationField = document.querySelector<HTMLInputElement>('#dialog-duration-field')

  if (dialogDurationField) {
    dialogDurationField.value = durationValue
  }
})

// Populate and open the block user confirmation dialog
on('click', '.js-block-user-button', function () {
  const blockUserDialog = document.getElementById('block-user-confirmation-dialog') as HTMLDialogElement
  if (!blockUserDialog) return

  const autocompleter = document.querySelector<AutocompleteElement>('.js-add-user-completer')
  const userLogin = autocompleter?.value || ''

  const dialogLoginField = blockUserDialog.querySelector<HTMLInputElement>('#dialog-login-field')
  const dialogDurationField = blockUserDialog.querySelector<HTMLInputElement>('#dialog-duration-field')

  if (dialogLoginField) {
    dialogLoginField.value = userLogin
  }

  if (dialogDurationField) {
    dialogDurationField.value = '0'
  }

  const userDisplayElement = blockUserDialog.querySelector<HTMLElement>('.js-blocked-user-display')

  if (userDisplayElement && userLogin) {
    const textTemplate = userDisplayElement.getAttribute('data-text-template')

    if (textTemplate) {
      userDisplayElement.textContent = textTemplate.replace('{username}', userLogin)
    }
  }

  const dialogSubmit = blockUserDialog.querySelector<HTMLButtonElement>('.js-add-new-user')

  if (dialogSubmit) {
    dialogSubmit.disabled = !userLogin
  }
})

export {resetUserAddForm}
